import { useContext, useMemo } from 'react';
import UFOInteractionContext from '../interaction-context';
import { getInteractionId } from '../interaction-id-context';
import { addCustomTiming, getCurrentInteractionType } from '../interaction-metrics';
export function getBm3Timings(marks, timingConfigs) {
  var bm3Timings = {};
  if (!marks || !timingConfigs) {
    return bm3Timings;
  }
  timingConfigs.forEach(function (item) {
    if (!item.startMark || !item.endMark) {
      return;
    }
    var startTime = marks[item.startMark];
    if (!startTime) {
      return;
    }
    var endTime = marks[item.endMark];
    if (!endTime) {
      return;
    }
    bm3Timings[item.key] = {
      startTime: startTime,
      endTime: endTime
    };
  });
  return bm3Timings;
}
export function UFOBM3TimingsToUFO(_ref) {
  var marks = _ref.marks,
    timings = _ref.timings;
  var interactionContext = useContext(UFOInteractionContext);
  var interactionId = getInteractionId().current;
  useMemo(function () {
    if (interactionContext != null && interactionId != null && marks != null && timings != null) {
      var interactionType = getCurrentInteractionType(interactionId);
      if (interactionType === 'press') {
        return;
      }
      var bm3Timings = getBm3Timings(marks, timings);
      interactionContext.addCustomTimings(bm3Timings);
    }
  }, [interactionContext, interactionId, marks, timings]);
  return null;
}
export function addBM3TimingsToUFO(marks, timingsConfig) {
  var interactionId = getInteractionId().current;
  if (interactionId) {
    var interactionType = getCurrentInteractionType(interactionId);
    if (interactionType === 'press') {
      return;
    }
    var bm3Timings = getBm3Timings(marks, timingsConfig);
    addCustomTiming(interactionId, [], bm3Timings);
  }
}